"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteNav = void 0;
const display_when_1 = require("@epic-mw/display-when");
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const SiteNavLargeLinks_1 = require("./SiteNavLargeLinks");
const SiteNavTabletLinks_1 = require("./SiteNavTabletLinks");
const Styled = styled_components_1.default.div `
	height: 100%;
	display: flex;
	align-items: center;
	text-align: center;
`;
const SiteNav = ({ links = [], collapseTargetMaxWidth, locale, topOffset, burgerCallback, }) => {
    const activeLink = (0, shared_1.useActiveLink)(links);
    const values = (0, epic_games_nav_shared_1.useBreakpointValues)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(display_when_1.DisplayWhenGreaterThanEqual, { width: values.lg },
            react_1.default.createElement(SiteNavLargeLinks_1.SiteNavLargeLinks, { key: "sitenav-desktop", links: links, activeLink: activeLink, collapseTargetMaxWidth: collapseTargetMaxWidth, locale: locale, topOffset: topOffset })),
        react_1.default.createElement(display_when_1.DisplayWhenLessThan, { width: values.lg },
            react_1.default.createElement(Styled, { key: "sitenav-tablet", className: "tablet" },
                react_1.default.createElement(SiteNavTabletLinks_1.SiteNavTabletLinks, { key: "sitenav-tablet", links: links, locale: locale, topOffset: topOffset, burgerCallback: burgerCallback })))));
};
exports.SiteNav = SiteNav;
//# sourceMappingURL=SiteNav.js.map